import { generatePath } from 'react-router-dom';
import { API_ROUTES } from '../consts';
import request from './index';

export const disconnectAtsIntegration = async (accountId: string): Promise<void> => {
  await request.delete(generatePath(API_ROUTES.DISCONNECT_ATS_INTEGRATION, { accountId }));
};
